require('./form')

const Onboarding_bloc = require('./blocs/onboarding')

$(function() {
  Onboarding_bloc()
})